// @ts-nocheck

import { ReactNode } from "react";
import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [cookies] = useCookies(["isLoggedInKIQ"]);

  // Check for token in URL query params (cross-domain handoff from chat.realestate)
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get("token");
  if (urlToken && !localStorage.getItem("auth_token")) {
    localStorage.setItem("auth_token", urlToken);
    localStorage.setItem("token", urlToken);
    console.log("🔑 [PROTECTED ROUTE] Token received from URL, stored in localStorage");
    // Clean token from URL without reload
    const cleanUrl = window.location.pathname + window.location.search.replace(/[?&]token=[^&]+/, '').replace(/^\?$/, '');
    window.history.replaceState({}, '', cleanUrl);
  }

  // Check for authentication token as fallback
  const hasToken = localStorage.getItem("auth_token");
  const isAuthenticated = cookies.isLoggedInKIQ || hasToken;
  
  console.log("🛡️ [PROTECTED ROUTE] Auth check:", {
    cookieAuth: cookies.isLoggedInKIQ,
    hasToken: !!hasToken,
    isAuthenticated
  });

  if (!isAuthenticated) {
    const isAISearchPortal = window.location.hostname.includes('aisearchportal.com');
    const loginPath = isAISearchPortal ? '/agent-portal/login' : '/sign-in';
    console.log("🚪 [PROTECTED ROUTE] Not authenticated, redirecting to", loginPath);
    return <Navigate to={loginPath} />;
  }

  return children;
};

export default ProtectedRoute;
